







































import AbpBase from "@/lib/abpbase";
import { Component, Prop, Watch } from "vue-property-decorator";
import PdMonitorChart from "../../chart.vue";
import DynamicColumnSelect from "../../dynamicColumnSelect.vue";
import {
  QueryPdMonitorSfChartData,
  GetPdAssessSfListForMonitor
} from "@/api/pdOutPatient/pdComprehensiveEvaluation/pdAssessSf";
@Component({
  components: {
    PdMonitorChart,
    DynamicColumnSelect
  }
})
export default class PdMonitorSf extends AbpBase {
  @Prop() patient: any;
  currentType: string = "0";
  chartData: any = null;
  showDyanmicColumnSelect: boolean = false;
  selectedColumns: any = [];
  data: any = [];
  buttons: any = [
    {
      type: "0",
      buttonText: "生理机能",
      onClick: (type: string) => {
        this.handleClick(type);
      }
    },
    {
      type: "1",
      buttonText: "生理职能",
      onClick: (type: string) => {
        this.handleClick(type);
      }
    },
    {
      type: "2",
      buttonText: "躯体疼痛",
      onClick: (type: string) => {
        this.handleClick(type);
      }
    },
    {
      type: "3",
      buttonText: "一般健康状况",
      onClick: (type: string) => {
        this.handleClick(type);
      }
    },
    {
      type: "4",
      buttonText: "精力",
      onClick: (type: string) => {
        this.handleClick(type);
      }
    },
    {
      type: "5",
      buttonText: "社会功能",
      onClick: (type: string) => {
        this.handleClick(type);
      }
    },
    {
      type: "6",
      buttonText: "情感职能",
      onClick: (type: string) => {
        this.handleClick(type);
      }
    },
    {
      type: "7",
      buttonText: "精神健康",
      onClick: (type: string) => {
        this.handleClick(type);
      }
    },
    {
      type: "8",
      buttonText: "健康变化",
      onClick: (type: string) => {
        this.handleClick(type);
      }
    }
  ];

  columns = [
    {
      title: "总评分",
      key: "result",
      width: 100
    },
    {
      title: "生理机能",
      key: "pf",
      width: 100
    },
    {
      title: "生理职能",
      key: "rp",
      width: 100
    },
    {
      title: "躯体疼痛",
      key: "bp",
      width: 100
    },
    {
      title: "一般健康状况",
      key: "gh",
      width: 140
    },
    {
      title: "精力",
      key: "vt",
      width: 100
    },
    {
      title: "社会功能",
      key: "sf",
      width: 100
    },
    {
      title: "情感职能",
      key: "re",
      width: 100
    },
    {
      title: "精神健康",
      key: "mh",
      width: 100
    },
    {
      title: "健康变化",
      key: "mt",
      width: 100
    }
  ];

  @Watch("patient", { immediate: true, deep: true })
  onPatientChanged() {
    this.selectedColumns = JSON.parse(JSON.stringify(this.columns)); //此处用数组拷贝的方式会出现错误“You may have an infinite update loop in watcher with expression "columns"”，故采用json序列化的方式拷贝数组，且render函数无效，需另外编写api数据接口
    this.insertAssessTime();
    if (this.patient.pD_Patient_ID) {
      this.handleClick("0");
      this.getData();
    }
  }

  //在第一列前面插入评估日期
  insertAssessTime() {
    this.selectedColumns.splice(0, 0, {
      title: "日期",
      key: "assessTime",
      minWidth: 120,
      render: (h: any, p: any) => {
        return h("div", {}, this.formatDate(p.row.assessTime));
      }
    });
  }

  async getData() {
    let res = await GetPdAssessSfListForMonitor(this.patient.pD_Patient_ID);
    this.data = res.objects;
  }

  handleDyanmicColumnSelectOk() {
    let res = this.$refs.DynamicColumnSelect.onSubmit();
    this.selectedColumns = JSON.parse(JSON.stringify(res));
    this.insertAssessTime();
  }

  async handleClick(type: string) {
    this.currentType = type;
    let payload = {
      pD_Patient_ID: this.patient.pD_Patient_ID,
      type: type
    };
    let res = await QueryPdMonitorSfChartData(payload);
    this.chartData = res.objects;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pdMonitor/pdMonitorIndex/parts/pdMonitorSf/index.vue